<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 41987 41939"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_891648480">
   <path class="fil0" d="M39072 0l-36075 0c-3496,0 -2912,5427 -2912,5427l41897 0c0,0 246,-5427 -2910,-5427z"/>
   <polygon class="fil0" points="0,14309 41939,14309 41939,8881 0,8881 "/>
   <polygon class="fil0" points="0,23683 41939,23683 41939,18256 0,18256 "/>
   <polygon class="fil0" points="0,32564 41939,32564 41939,27137 0,27137 "/>
   <polygon class="fil0" points="0,41939 41939,41939 41939,36018 0,36018 "/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'SunBlind',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
